import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';

export default function Login() {
  const { instance, inProgress } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center gap-6">
        {/* Logo */}
        <div className="flex flex-col items-center gap-1">
          <div className="w-16 h-16 bg-otm-orange rounded-xl flex items-center justify-center">
            <span className="text-white font-bold text-2xl">OC</span>
          </div>
          <h1 className="text-xl font-bold text-slate-800 mt-2">OtimizCred</h1>
          <p className="text-sm text-slate-500">CRM Imobiliário</p>
        </div>

        <div className="w-full h-px bg-slate-100" />

        <div className="w-full flex flex-col gap-3">
          <p className="text-sm text-slate-600 text-center">
            Acesse com sua conta corporativa Microsoft
          </p>

          <button
            onClick={handleLogin}
            disabled={inProgress !== 'none'}
            className="w-full flex items-center justify-center gap-3 bg-[#0078d4] hover:bg-[#106ebe] active:bg-[#005a9e] text-white font-medium py-3 px-4 rounded-lg transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {/* Ícone Microsoft */}
            <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="9" height="9" fill="#F25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
              <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
            {inProgress !== 'none' ? 'Entrando...' : 'Entrar com Microsoft'}
          </button>
        </div>

        <p className="text-xs text-slate-400 text-center">
          Uso restrito · OTM Group
        </p>
      </div>
    </div>
  );
}
